import { render, staticRenderFns } from "./ClaimsOrdersSearch.vue?vue&type=template&id=05f452f6"
import script from "./ClaimsOrdersSearch.vue?vue&type=script&lang=js"
export * from "./ClaimsOrdersSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports